<template lang="html">
	<section class="take-place contacts-container column">
		<div class="attached-item row">
			<div class="phantom-flex"></div>
			<div class="listing row">
				<div class="bold">
					{{ clients.length }} client{{ (clients.length > 1) ? 's&nbsp;' : '&nbsp;' }}
				</div>
				<div v-if="prospectInContacts > 0">
					dont {{ prospectInContacts }} prospect{{ (prospectInContacts > 1) ? 's' : '' }}
				</div>
			</div>
			<div class="ctn-cta">
				<div class="btn btn-red" @click="showAddContact = true">
					<span class="icon-button-contact"></span> Ajouter un contact
				</div>
			</div>
		</div>
		<ag-table :rows="clients" :columns="cols" :customOptions="options" :addSearch="true" />
		<base-modal :show="showAddContact" @close="showAddContact = false" :content="contentModal" />
	</section>
</template>

<script>
import { mapGetters } from 'vuex'
import ModalAddContact from '@/components/Modal/AddContact'

export default {
	name: 'Contacts',
	data () {
		return {
			cols: [
				{ name: '', field: 'picture', cellType: 'roundImg', width: 60, cellClass: 'no-padding' },
				{ name: 'Nom Complet', field: 'name', cellType: 'compactName' },
				{ name: 'Type', field: 'type', cellType: 'typeContact', width: 140 },
				{ name: 'Téléphone', field: 'phone', cellType: 'light', width: 160 },
				{ name: 'Mail', field: 'email', cellType: 'noUpper', width: 300 },
				{ name: 'Tâche en cours', field: 'currentTask', cellType: 'currentTask' },
				{ name: 'Prochain RDV', field: 'nextAppointment', cellType: 'shortDate', width: 150 }
			],
			showAddContact: false,
			contentModal: ModalAddContact,
			options: {
				onCellClicked: (data) => {
					this.$router.push({name: 'Client', params: { clientId: data.data.id }})
				}
			}
		}
	},
	mounted () {
		this.$store.dispatch('getClients')
	},
	computed: {
		...mapGetters({
			clients: 'getClients'
		}),
		prospectInContacts () {
			return this.clients.filter(contact => (contact.type !== 'client_subscriber' && contact.type !== 'Client')).length
		}
	},
}
</script>

<style lang="scss">
	.ag-body-container {
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// Table.vue?07ec4a3f